<template>
    <div :class="[
        'cz2__panel',
        'cz2__panel--secondary',
        'cz2__colors',
        'cz2__colors--' + smallStep
    ]">
        <focus-lock :disabled="focusLockDisabled">
            <div class="cz2__panel__header cz2__panel__header--with-back-button hide--below-sm">
                <div class="cz2__panel-header__back-button">
                    <button class="cz2__panel__back-button" :aria-label="$t('MENU_BACK')" @click.prevent="cancel"></button>
                </div>

                <details-header></details-header>
            </div>

            <div class="cz2__panel__body">
                <panel-header
                    v-if="this.smallStep === 'color'"
                    :title="`${colorStepTitle} &mdash; ${selectedColor}`"
                    :subtitle="`${methodsDescriptionSmall}`"
                />

                <!-- <div class="cz2__panel-body__back-button hide--below-sm">
                    <button class="cz2__panel__back-button" @click.prevent="cancel">
                        {{colorStepTitle}} &mdash; {{selectedColor}}
                    </button>
                </div> -->

                <!-- <div class="cz2__colors__color-header">
                    <div class="cz2__type__small-header cz2__text--center hide--above-sm">
                        {{colorStepTitle}} &mdash; {{selectedColor}}
                    </div>

                    <div class="cz2__type__micro cz2__text--center hide--above-sm cz2__colors__methods">
                        {{methodsDescriptionSmall}}
                    </div>
                </div> -->

                <!-- Color Options -->
                <div class="cz2__colors__options">
                    <div class="cz2__color-filler"></div>
                    <button v-for="color in availableColors" :key="color.option.code"
                        :class="[
                            'cz2__color-option',
                            {
                                'cz2__color-option--selected': color.selected,
                                'cz2__color-option--unavailable': color.ats == null || color.ats === 0,
                            }
                        ]"
                        :data-color="color.option.code"
                        @click.prevent="selectColor(color)"
                        :aria-label="color.name"
                    >
                        <span class="cz2__color-option__color" :style="color.style">
                        </span>

                        <span class="cz2__color-option__name">
                            {{color.name}}
                        </span>
                    </button>
                    <div class="cz2__color-filler"></div>
                </div>

                <!-- Color Options -->
                <div class="cz2__colors__printing">
                    <div class="cz2__type__small-header">
                        {{$t('COLORS_PRINTING')}}
                        <span>&mdash; {{selectedMethodTitle}}</span>
                    </div>

                    <div class="cz2__colors__printing-options">
                        <button v-for="method in availableMethods" :key="method.type"
                            :class="[
                                'cz2__printing-option',
                                {
                                    'cz2__printing-option--selected': method.selected,
                                }
                            ]"
                            :disabled="!method.available"
                            @click.prevent="selectMethod(method)"
                        >
                            <span :class="['cz2__printing-option__icon', 'cz2__printing-option__icon--' + method.type]"></span>

                            <span class="cz2__printing-option__description">
                                <span class="cz2__printing-option__name cz2__type__mini-header">{{method.name}}</span>
                                <span class="cz2__printing-option__notes cz2__type__tiny">{{method.notes}}</span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="cz2__panel__actions cz2__colors__actions--save-color hide--above-sm">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancel"><span>{{$t('ACTION_CANCEL')}}</span></button>
                <button class="cz2__panel-action cz2__panel-action--accept" @click.prevent="acceptColor"><span>{{$t('ACTION_SAVE')}}</span></button>
            </div>

            <div class="cz2__panel__actions cz2__colors__actions--save-method hide--above-sm">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="backColor"><span>{{$t('MENU_BACK')}}</span></button>
                <button class="cz2__panel-action cz2__panel-action--accept" @click.prevent="accept"><span>{{$t('ACTION_SAVE')}}</span></button>
            </div>

            <div class="cz2__panel__actions cz2__colors__actions--save-panel">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancel"><span>{{$t('ACTION_CANCEL')}}</span></button>
                <button class="cz2__panel-action cz2__panel-action--accept" @click.prevent="accept"><span>{{$t('ACTION_SAVE')}}</span></button>
            </div>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__colors {
            @include respond-below(sm) {
                // .cz2__colors__methods {
                //     margin-top: 5px;
                // }

                .cz2__colors__actions--save-panel {
                    display: none;
                }

                .cz2__colors__actions--save-method {
                    display: none;
                }

                .cz2__colors__actions--save-color {
                    display: none;
                }

                &.cz2__colors--color {
                    .cz2__colors__printing {
                        display: none;
                    }

                    .cz2__colors__actions--save-color {
                        display: flex;
                    }
                }

                &.cz2__colors--method {
                    .cz2__colors__actions--save-method {
                        display: flex;
                    }

                    .cz2__colors__color-header {
                        display: none;
                    }

                    .cz2__colors__options {
                        display: none;
                    }

                    .cz2__colors__printing {
                        display: block;

                        margin-top: 0;

                        .cz2__type__small-header {
                            text-align: center;
                        }

                        .cz2__colors__printing-options {
                            display: flex;
                            flex-direction: row;
                        }

                        .cz2__printing-option {
                            flex-direction: column;

                            margin-top: 0;
                        }

                        .cz2__printing-option__icon {
                            margin-right: 0;
                        }

                        .cz2__printing-option__description {
                            width: auto;
                            margin-top: 7px;
                        }

                        .cz2__printing-option__name {
                            font-size: 10px;
                            line-height: 12px;
                        }

                        .cz2__printing-option__notes {
                            display: none;
                        }
                    }
                }
            }
        }

        .cz2__colors__printing-options {
            display: flex;
            flex-direction: column;

            margin-top: 25px;
        }

        .cz2__printing-option {
            display: flex;
            align-items: center;

            width: 100%;
            height: $button-height;

            &:disabled {
                opacity: 0.4;
            }

            & + .cz2__printing-option {
                margin-top: 25px;
            }

            &.cz2__printing-option--selected {
                .cz2__printing-option__icon {
                    position: relative;

                    &:after {
                        content: '';

                        display: block;
                        position: absolute;

                        width: $icon-size;
                        height: $icon-size;

                        border-radius: $icon-size;

                        border: 2px solid #000;
                    }
                }
            }
        }

        .cz2__printing-option__icon {
            display: block;
            flex: 0 0 auto;

            width: $icon-size;
            height: $icon-size;

            margin-right: 12px;

            &.cz2__printing-option__icon--etching {
                background: transparent url(../assets/color-etch@2x.png) no-repeat center/contain;
            }

            &.cz2__printing-option__icon--printing {
                background: transparent url(../assets/color-print@2x.png) no-repeat center/contain;
            }
        }

        .cz2__printing-option__description {
            flex: 1 0 auto;
            width: 1px;

            text-align: left;
        }

        .cz2__printing-option__name {
            display: block;
        }

        .cz2__printing-option__notes {
            display: block;
            line-height: 13px;
            margin-top: 2px;
        }

        .cz2__colors__printing {
            margin-top: 30px;
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';
    import DetailsHeader from './DetailsHeader.vue';
    import PanelHeader from './PanelHeader.vue';

    import * as constants from '../constants';

    export default {
        components: {
            FocusLock,
            DetailsHeader,
            PanelHeader,
        },
        data() {
            return {
                focusLockDisabled: true,

                smallStep: 'color',
            };
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Color step caption.
             */
            colorStepTitle() {
                return this.$store.getters.colorStepTitle;
            },

            /**
             * Currently selected color name.
             */
            selectedColor() {
                return this.$store.getters.selectedColor;
            },

            /**
             * Selected personalization method.
             */
            selectedPersonalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },

            productData() {
                return this.$store.state.ecommerce.products;
            },

            /**
             * Generate a list of available components.
             */
            availableColors() {
                if (this.viewController == null) {
                    return [];
                }

                const productPlacement = this.viewController.findPlacement(constants.PLACEMENT_PRODUCT);

                const selected = this.viewController.selectedAtPlacement(constants.PLACEMENT_PRODUCT);

                const colors = productPlacement.components.map((c) => {
                    let ats = 0;

                    const product = this.productData.find((p) => p.productId === c.placementIndependentCode);
                    if (product && product.online) {
                        ats = product.ats;
                    }

                    const color = {
                        option: c,
                        selected: selected.code === c.code,
                        style: this.getColorStyle(c),
                        ats,
                    };

                    const definition = c.description.find((d) => d.definition === constants.DEFINITION_PRODUCT);

                    if (definition) {
                        color.name = definition.description;
                    }

                    return color;
                });

                return colors;
            },

            /**
             * Gets description of printing methods for small screens.
             */
            methodsDescriptionSmall() {
                if (this.viewController == null) {
                    return '';
                }

                // const selected = this.viewController.selectedAtPlacement(constants.PLACEMENT_PRODUCT);

                // Use a standard message instead.
                // return selected.custom['v-methods-description-small'] || '';

                return this.$t('METHODS_SMALL');
            },

            /**
             * Selected method title.
             */
            selectedMethodTitle() {
                if (this.selectedPersonalizationMethod === 'etching') {
                    return this.$t('PRINTING_ETCHING');
                }

                if (this.selectedPersonalizationMethod === 'printing') {
                    return this.$t('PRINTING_PRINTING');
                }

                return '';
            },

            /**
             * Generate a list of available printing options.
             */
            availableMethods() {
                const methods = [];

                const selected = this.viewController.selectedAtPlacement(constants.PLACEMENT_PRODUCT);

                const { supportsEtching, supportsPrinting } = this.getSupported(selected);

                this.availableColors.forEach((color) => {
                    if (color.option.custom['v-supports-etching'] === 'true') {
                        if (methods.find((m) => m.type === 'etching') == null) {
                            const notes = this.viewController.blueprint.custom['v-etching-description'];

                            methods.push({
                                type: 'etching',
                                selected: this.selectedPersonalizationMethod === 'etching',
                                name: this.$t('PRINTING_ETCHING'),
                                notes,
                                available: supportsEtching,
                            });
                        }
                    }

                    if (color.option.custom['v-supports-printing'] === 'true') {
                        if (methods.find((m) => m.type === 'printing') == null) {
                            const notes = this.viewController.blueprint.custom['v-printing-description'];

                            methods.push({
                                type: 'printing',
                                selected: this.selectedPersonalizationMethod === 'printing',
                                name: this.$t('PRINTING_PRINTING'),
                                notes,
                                available: supportsPrinting,
                            });
                        }
                    }
                });

                return methods;
            },

            isGroupOrder() {
                return this.$store.state.isGroupOrder;
            },
        },
        mounted() {
            // Otherwise this messes with transition animation because browsers will try to scroll to the focused item, which would be off-screen.
            this.$store.state.eventBus.$once('secondaryEntered', () => {
                // this.focusLockDisabled = false;
            });

            // When the component is loaded, capture the current state of the view controller and save it in case
            // we need to revert to the previous state and toss away all customizations.
            //
            // At any given time there should be only one module that can do the revert.
            this.captureController();
        },
        methods: {
            /**
             * Captures the current state and active controller so we could cancel changes if necessary.
             */
            captureController() {
                if (this.viewController) {
                    this.revertController = this.viewController.clone({ excludeEvents: false });
                    this.revertMethod = this.selectedPersonalizationMethod;
                }
            },

            /**
             * Accept color choice.
             */
            accept() {
                if (this.cutQuantity != null) {
                    if (this.isGroupOrder) {
                        this.$store.dispatch('setSecondaryBottles', this.$store.state.customizer.secondaryBottles.slice(0, this.cutQuantity));
                    } else {
                        this.$store.dispatch('setQuantity', this.cutQuantity);
                    }
                }

                // Keep the current configured view controller, and go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Reject color changes and restore the original selection.
             */
            cancel() {
                // Revert back to the state of the controller as was captured when the component was mounted.
                this.$store.dispatch('showController', this.revertController);
                this.$store.dispatch('setPersonalizationMethod', this.revertMethod);

                // Go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Selects a color component, and makes sure that sizes are properly selected.
             */
            selectColor(color) {
                const continueSelect = (newCutQuantity) => {
                    const newColorComponent = this.viewController.findComponent(color.option.code);
                    const { supportsEtching, supportsPrinting } = this.getSupported(newColorComponent);
                    const needsSwitchToEtching = this.selectedPersonalizationMethod === 'printing' && !supportsPrinting;
                    const needsSwitchToPrinting = this.selectedPersonalizationMethod === 'etching' && !supportsEtching;

                    // Handing printing type switching ( also reset / set cut quantity if needed)
                    if (needsSwitchToEtching || needsSwitchToPrinting) {
                        const confirmModal = needsSwitchToEtching ? this.switchToEtchingConfirm : this.switchToPrintingConfirm;
                        const newPersonalizationMethod = this.selectedPersonalizationMethod === 'printing' ? 'etching' : 'printing';
                        this.cutQuantity = null;
                        confirmModal(() => {
                            this.cutQuantity = newCutQuantity;
                            this.$store.dispatch('setPersonalizationMethod', newPersonalizationMethod);
                            this.viewController.updateComponent(constants.PLACEMENT_PRODUCT, color.option.code);
                        });
                    } else {
                        this.viewController.updateComponent(constants.PLACEMENT_PRODUCT, color.option.code);
                    }
                };

                if (color.ats > 0) {
                    let requiredQuantity = null;

                    if (this.isGroupOrder) {
                        requiredQuantity = this.$store.state.customizer.secondaryBottles.length;
                    } else {
                        requiredQuantity = this.$store.state.customizer.quantity;
                    }

                    // Inventory popup
                    if (color.ats >= requiredQuantity) {
                        this.cutQuantity = null;

                        continueSelect(null);
                    } else {
                        this.$store.dispatch('showGenericConfirm', {
                            title: this.$t('QUANTITY_WARNING', {
                                ats: color.ats,
                                items: color.ats > 1 ? this.$t('QUANTITY_ITEMS') : this.$t('QUANTITY_ITEM'),
                            }),
                            description: this.$t('QUANTITY_WARNING_BODY'),
                            cancelAction: this.$t('ACTION_CANCEL'),
                            confirmAction: this.$t('ACTION_CONTINUE'),
                            confirmationCallback: () => {
                                this.cutQuantity = color.ats;

                                continueSelect(color.ats);
                            },
                        });
                    }
                }
            },

            /**
             * Confirmation modal for switching to etching
             */
            switchToEtchingConfirm(callback) {
                this.$store.dispatch('showGenericConfirm', {
                    title: this.$t('COLORS_ARE_YOU_SURE_ETCHING'),
                    description: this.$t('COLORS_CUSTOMIZATIONS_WILL_BE_LOST'),
                    cancelAction: this.$t('COLORS_STAY_FULL_COLOR'),
                    confirmAction: this.$t('COLORS_CONFIRM_ETCHING'),
                    confirmationCallback: () => {
                        callback();
                    },
                });
            },

            /**
             * Confirmation modal for switching to full color printing
             */
            switchToPrintingConfirm(callback) {
                this.$store.dispatch('showGenericConfirm', {
                    title: this.$t('COLORS_ARE_YOU_SURE_FULL_COLOR'),
                    description: this.$t('COLORS_CUSTOMIZATIONS_WILL_BE_LOST'),
                    cancelAction: this.$t('COLORS_STAY_ETCHING'),
                    confirmAction: this.$t('COLORS_CONFIRM_FULL_COLOR'),
                    confirmationCallback: () => {
                        callback();
                    },
                });
            },

            /**
             * Gets color swatch style.
             */
            getColorStyle(color) {
                const css = {};

                if (color && color.custom && color.custom.hex) {
                    css.backgroundColor = color.custom.hex.startsWith('#') ? color.custom.hex : `#${color.custom.hex}`;
                }

                return css;
            },

            /**
             * Checks which printing methods a component supports.
             */
            getSupported(selected) {
                const supportsEtching = selected.custom['v-supports-etching'] === 'true';
                const supportsPrinting = selected.custom['v-supports-printing'] === 'true';

                return {
                    supportsEtching,
                    supportsPrinting,
                };
            },

            /**
             * Sets personalization method, confirm choice first
             */
            selectMethod(method) {
                if (this.selectedPersonalizationMethod !== method.type) {
                    const confirmModal = method.type === 'printing' ? this.switchToPrintingConfirm : this.switchToEtchingConfirm;
                    confirmModal(() => {
                        this.$store.dispatch('setPersonalizationMethod', method.type);
                    });
                }
            },

            /**
             * Accepts color selection on mobile.
             */
            acceptColor() {
                this.smallStep = 'method';
            },

            /**
             * Navigates back to the color selection.
             */
            backColor() {
                this.smallStep = 'color';
            },
        },
    };
</script>
